export default "__VITE_ASSET__BYRZdQvO__"